module.exports = __webpack_public_path__ + "static/media/24UHCHR1.c9da57ae.jpg";